import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import { useLibertyMutualSubStepsContext } from '../../../context';
import { Topic, Value } from '../styles';

export const FileOriginalName = () => {
	const {
		libertyMutualResult: {
			informations: { original_name }
		}
	} = useLibertyMutualSubStepsContext();

	return (
		<Col xs={24}>
			<Topic>{I18n.get('File')}:</Topic>
			<Value>{original_name}</Value>
		</Col>
	);
};
